import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';
import InvoicesContent from '../../components/Pages/Invoices';

const { displayName } = config;

export default function Invoices(): React.ReactNode | null {
  document.title = `${displayName}: Invoices`;

  return (
    <Layout
      title="Invoices"
      leftMenu={<Menu />}
    >
      <InvoicesContent />
    </Layout>
  );
}
